import React, { Fragment, useEffect } from 'react';

import { MapTo } from '@adobe/aem-react-editable-components';

import { NetworkConnectionSubtitle } from 'components/ExpertSearch/components/NetworkConnectionSubtitle/NetworkConnectionSubtitle';
import { PageTitleSection } from 'components/PageTitleSection/PageTitleSection';
import { SubTitle } from 'components/SubTitle/SubTitle';

const CONTENT = {
  title: 'Installateurbetreuung',
  firstDescription:
    'Bei Fragen zu Ihrem Eintrag in unserem Installateur-Verzeichnis, Ausweisverlängerungen, dem Vorgehen bei Änderung des Firmensitzes, Umfirmierung oder Änderung von Fachkräften wenden Sie sich an das gemeinsame Postfach:',
  firstDescriptionEmail: 'installateure@bayernwerk.de',
  items: [
    {
      title: 'Technischen Kundenservice für Strom und Erdgas:',
      text: 'Tel. 0941-28 00 33 11',
    },
    {
      title: 'Zähler und Messeinrichtungen:',
      text: 'Tel. 09 41-28 00 33 77',
    },
    {
      title: 'Installateurverzeichnis:',
      text: 'Bei Fragen zu Ihrem Eintrag Installateur-Verzeichnis, Ausweisverlängerungen, dem Vorgehen bei Änderung des Firmensitzes, Umfirmierung oder Änderung von Fachkräften wenden Sie sich an das gemeinsame Postfach:',
      email: 'installateure@bayernwerk.de',
    },
  ],
};

const InstallerSupportComponent = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { title, firstDescription, firstDescriptionEmail, items } = CONTENT;

  return (
    <div className=" expert-page">
      <div className="expert-page-content-stage-text">
        <PageTitleSection title={title} notFramed />
        <NetworkConnectionSubtitle
          description={firstDescription}
          descriptionEmail={firstDescriptionEmail}
        />
        {items.map(({ title: itemTtitle, text, email }) => (
          <Fragment key={itemTtitle}>
            <SubTitle text={itemTtitle} notFramed />
            <NetworkConnectionSubtitle description={text} descriptionEmail={email} />
          </Fragment>
        ))}
      </div>
    </div>
  );
};

MapTo(['e-fix/components/content/baginstallersupport'])(InstallerSupportComponent);
